var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTiktok = function SvgTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 34c9.389 0 17-7.611 17-17S26.389 0 17 0 0 7.611 0 17s7.611 17 17 17Zm7.348-22.13a4.647 4.647 0 0 1-3.655-4.116v-.427h-3.34V20.58a2.808 2.808 0 0 1-5.04 1.69 2.807 2.807 0 0 1 3.085-4.372v-3.393a6.135 6.135 0 1 0 5.296 6.076v-6.773a7.93 7.93 0 0 0 4.627 1.48V11.97c-.327 0-.653-.034-.973-.101Z",
    fill: "#2C112D"
  })));
};
export default SvgTiktok;